import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "question-card"
};
const _hoisted_2 = { class: "card-header" };
const _hoisted_3 = {
    key: 0,
    class: "card-title"
};
const _hoisted_4 = { class: "q-text" };
const _hoisted_5 = { class: "q-key" };
const _hoisted_6 = {
    key: 1,
    class: "card-title"
};
const _hoisted_7 = { class: "q-text" };
const _hoisted_8 = { class: "card-actions" };
const _hoisted_9 = {
    key: 0,
    class: "card-body"
};
const _hoisted_10 = { class: "info-item" };
const _hoisted_11 = { class: "info-item" };
const _hoisted_12 = { class: "info-item" };
const _hoisted_13 = {
    key: 0,
    class: "info-item"
};
const _hoisted_14 = {
    key: 1,
    class: "info-item"
};
const _hoisted_15 = {
    key: 2,
    class: "answers-view"
};
const _hoisted_16 = { class: "q-key" };
const _hoisted_17 = { class: "settings-view" };
const _hoisted_18 = {
    key: 1,
    class: "card-body"
};
const _hoisted_19 = { class: "form-row" };
const _hoisted_20 = { class: "form-group" };
const _hoisted_21 = { class: "form-group" };
const _hoisted_22 = { class: "q-key" };
const _hoisted_23 = { class: "form-group" };
const _hoisted_24 = { class: "form-group" };
const _hoisted_25 = { class: "form-row" };
const _hoisted_26 = { class: "form-group" };
const _hoisted_27 = ["value"];
const _hoisted_28 = { class: "form-group" };
const _hoisted_29 = { class: "form-group" };
const _hoisted_30 = {
    key: 0,
    class: "settings-edit"
};
const _hoisted_31 = { class: "form-row" };
const _hoisted_32 = { class: "checkbox-label" };
const _hoisted_33 = { class: "checkbox-label" };
const _hoisted_34 = { class: "form-row" };
const _hoisted_35 = { class: "form-group" };
const _hoisted_36 = { class: "form-group" };
const _hoisted_37 = { class: "form-group" };
const _hoisted_38 = { class: "form-row" };
const _hoisted_39 = { class: "form-group" };
const _hoisted_40 = { class: "form-group" };
const _hoisted_41 = {
    key: 1,
    class: "answers-edit"
};
const _hoisted_42 = ["onDragstart", "onDrop"];
const _hoisted_43 = ["onUpdate:modelValue"];
const _hoisted_44 = ["onUpdate:modelValue"];
const _hoisted_45 = ["onUpdate:modelValue"];
const _hoisted_46 = ["onUpdate:modelValue"];
const _hoisted_47 = ["onClick"];
const _hoisted_48 = { class: "answer-edit-item" };
import { ref, computed, watch, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuestionCard',
    props: {
        question: {},
        questionnaireId: { default: null },
        initEditMode: { type: Boolean, default: false },
        isNewQuestion: { type: Boolean, default: false }
    },
    emits: ["change", "created", "cancel-new", "message", "error"],
    setup(__props, { emit: __emit }) {
        const admin = useAdmin();
        const props = __props;
        const emit = __emit;
        const localQuestion = ref(null);
        const editMode = ref(false);
        const newAnswerText = ref('');
        const newAnswerValue = ref('');
        const newAnswerIcon = ref('');
        const newAnswerSubText = ref('');
        const draggedAnswerIndex = ref(null);
        const questionTypeOptions = [
            { value: 0, text: 'Free text' },
            { value: 1, text: 'Free text (number)' },
            { value: 2, text: 'Free text (currency)' },
            { value: 3, text: 'Free text (%)' },
            { value: 4, text: 'Multiple choice' },
            { value: 5, text: 'Dropdown' }
        ];
        const isChoiceType = computed(() => localQuestion.value?.questionType === 4 || localQuestion.value?.questionType === 5);
        const orderedAnswers = computed(() => {
            const answers = localQuestion.value?.possibleAnswers;
            if (!answers)
                return [];
            return [...answers].sort((a, b) => (a.order || 0) - (b.order || 0));
        });
        function questionTypeText(type) {
            return questionTypeOptions.find(o => o.value === type)?.text || 'Unknown';
        }
        function copyQuestion() {
            const copy = JSON.parse(JSON.stringify(props.question));
            if (!copy.possibleAnswers)
                copy.possibleAnswers = [];
            copy.possibleAnswers.forEach((a, i) => {
                if (a.order === undefined)
                    a.order = i;
            });
            localQuestion.value = copy;
        }
        watch(() => props.question, copyQuestion, { deep: true });
        function filterKeyInput(event) {
            localQuestion.value.key = event.target.value.replace(/\s+/g, '');
        }
        function handleEdit() {
            if (editMode.value) {
                saveQuestion();
            }
            else {
                editMode.value = true;
            }
        }
        function handleCancelRemove() {
            if (editMode.value) {
                if (!localQuestion.value.id)
                    emit('cancel-new');
                editMode.value = false;
                copyQuestion();
                return;
            }
            if (props.questionnaireId) {
                admin.removeQuestionFromQuestionnaire(props.questionnaireId, localQuestion.value.id, () => {
                    emit('message', 'Removed question from questionnaire');
                    emit('change');
                });
            }
            else {
                admin.deleteQuestion(localQuestion.value.id, () => {
                    emit('message', 'Deleted question');
                    emit('change');
                });
            }
        }
        function saveQuestion() {
            const question = localQuestion.value;
            if (!question.id) {
                delete question.id;
                admin.createQuestion(question, (created) => {
                    localQuestion.value = created;
                    editMode.value = false;
                    emit('message', 'Created question');
                    if (props.questionnaireId) {
                        admin.addQuestionToQuestionnaire(props.questionnaireId, created.id, () => emit('created', created));
                    }
                    else {
                        emit('created', created);
                    }
                }, () => emit('error', 'Failed to create question'));
            }
            else {
                admin.updateQuestion(question.id, question, (updated) => {
                    localQuestion.value = updated;
                    editMode.value = false;
                    emit('message', 'Updated question');
                    emit('change');
                }, () => emit('error', 'Failed to save question'));
            }
        }
        function addAnswer() {
            if (!newAnswerText.value)
                return;
            localQuestion.value.possibleAnswers.push({
                answer: { text: newAnswerText.value, subText: newAnswerSubText.value || null, value: newAnswerValue.value, icon: newAnswerIcon.value || null },
                order: localQuestion.value.possibleAnswers.length
            });
            newAnswerText.value = '';
            newAnswerValue.value = '';
            newAnswerIcon.value = '';
            newAnswerSubText.value = '';
        }
        function removeAnswer(answer) {
            const answers = localQuestion.value.possibleAnswers;
            answers.splice(answers.indexOf(answer), 1);
            answers.forEach((a, i) => (a.order = i));
        }
        function pickupAnswer(index) {
            draggedAnswerIndex.value = index;
        }
        function dropAnswer(index) {
            const from = draggedAnswerIndex.value;
            if (from === null || from === index)
                return;
            const answers = orderedAnswers.value;
            const [moved] = answers.splice(from, 1);
            answers.splice(index, 0, moved);
            answers.forEach((a, i) => (a.order = i));
            localQuestion.value.possibleAnswers = answers;
            draggedAnswerIndex.value = null;
        }
        onMounted(() => {
            copyQuestion();
            editMode.value = props.initEditMode;
        });
        return (_ctx, _cache) => {
            return (localQuestion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (!editMode.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, _toDisplayString(localQuestion.value.text), 1),
                                _createElementVNode("div", _hoisted_5, "Fact card name: Q_" + _toDisplayString((localQuestion.value.key || '').toUpperCase()), 1)
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.isNewQuestion ? 'New question' : 'Editing question'), 1)
                            ])),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("button", {
                                class: "action-btn primary",
                                onClick: handleEdit
                            }, _toDisplayString(editMode.value ? '💾 Save' : '✏️ Edit'), 1),
                            _createElementVNode("button", {
                                class: _normalizeClass(["action-btn", editMode.value ? 'secondary' : 'danger']),
                                onClick: handleCancelRemove
                            }, _toDisplayString(editMode.value ? 'Cancel' : (_ctx.questionnaireId ? '➖ Remove' : '🗑️ Delete')), 3)
                        ])
                    ]),
                    (!editMode.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Type:", -1)),
                                _createTextVNode(" " + _toDisplayString(questionTypeText(localQuestion.value.questionType)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Sub text:", -1)),
                                _createTextVNode(" " + _toDisplayString(localQuestion.value.subText || '—'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _cache[23] || (_cache[23] = _createElementVNode("strong", null, "Description:", -1)),
                                _createTextVNode(" " + _toDisplayString(localQuestion.value.description || '—'), 1)
                            ]),
                            (localQuestion.value.correctAnswer)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _cache[24] || (_cache[24] = _createElementVNode("strong", null, "Correct answer:", -1)),
                                    _createTextVNode(" " + _toDisplayString(localQuestion.value.correctAnswer), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (localQuestion.value.explainer)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _cache[25] || (_cache[25] = _createElementVNode("strong", null, "Explainer:", -1)),
                                    _createTextVNode(" " + _toDisplayString(localQuestion.value.explainer), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (orderedAnswers.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _cache[26] || (_cache[26] = _createElementVNode("strong", null, "Possible answers:", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderedAnswers.value, (a, i) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: i,
                                            class: "answer-view-item"
                                        }, [
                                            _createElementVNode("div", null, _toDisplayString(a.answer.text), 1),
                                            _createElementVNode("div", _hoisted_16, "Sub text: " + _toDisplayString(a.answer.subText || '—') + " · Value: " + _toDisplayString(a.answer.value || '—') + " · Icon: " + _toDisplayString(a.answer.icon || '—'), 1)
                                        ]));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("span", null, [
                                    _cache[27] || (_cache[27] = _createElementVNode("strong", null, "Multiple choice:", -1)),
                                    _createTextVNode(" " + _toDisplayString(localQuestion.value.multipleChoice ? 'Yes' : 'No'), 1)
                                ]),
                                _createElementVNode("span", null, [
                                    _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Out of:", -1)),
                                    _createTextVNode(" " + _toDisplayString(localQuestion.value.outOf ? 'Yes' : 'No'), 1)
                                ]),
                                _createElementVNode("span", null, [
                                    _cache[29] || (_cache[29] = _createElementVNode("strong", null, "Min:", -1)),
                                    _createTextVNode(" " + _toDisplayString(localQuestion.value.minAmount), 1)
                                ]),
                                _createElementVNode("span", null, [
                                    _cache[30] || (_cache[30] = _createElementVNode("strong", null, "Max:", -1)),
                                    _createTextVNode(" " + _toDisplayString(localQuestion.value.maxAmount), 1)
                                ]),
                                _createElementVNode("span", null, [
                                    _cache[31] || (_cache[31] = _createElementVNode("strong", null, "Default:", -1)),
                                    _createTextVNode(" " + _toDisplayString(localQuestion.value.defaultAmount), 1)
                                ]),
                                _createElementVNode("span", null, [
                                    _cache[32] || (_cache[32] = _createElementVNode("strong", null, "Min label:", -1)),
                                    _createTextVNode(" " + _toDisplayString(localQuestion.value.minLabel), 1)
                                ]),
                                _createElementVNode("span", null, [
                                    _cache[33] || (_cache[33] = _createElementVNode("strong", null, "Max label:", -1)),
                                    _createTextVNode(" " + _toDisplayString(localQuestion.value.maxLabel), 1)
                                ])
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                    _cache[34] || (_cache[34] = _createElementVNode("label", null, "Question text", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((localQuestion.value.text) = $event)),
                                        type: "text",
                                        class: "form-input",
                                        placeholder: "Enter your question"
                                    }, null, 512), [
                                        [_vModelText, localQuestion.value.text]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                    _cache[35] || (_cache[35] = _createElementVNode("label", null, "Question key", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((localQuestion.value.key) = $event)),
                                        type: "text",
                                        class: "form-input",
                                        maxlength: "10",
                                        placeholder: "Enter question key",
                                        onInput: filterKeyInput
                                    }, null, 544), [
                                        [_vModelText, localQuestion.value.key]
                                    ])
                                ])
                            ]),
                            _createElementVNode("p", _hoisted_22, "Fact card name: Q_" + _toDisplayString((localQuestion.value.key || '').toUpperCase()), 1),
                            _createElementVNode("div", _hoisted_23, [
                                _cache[36] || (_cache[36] = _createElementVNode("label", null, "Sub text", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((localQuestion.value.subText) = $event)),
                                    type: "text",
                                    class: "form-input",
                                    placeholder: "Shown under the question"
                                }, null, 512), [
                                    [_vModelText, localQuestion.value.subText]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                                _cache[37] || (_cache[37] = _createElementVNode("label", null, "Description", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((localQuestion.value.description) = $event)),
                                    type: "text",
                                    class: "form-input",
                                    placeholder: "Shown below the answers"
                                }, null, 512), [
                                    [_vModelText, localQuestion.value.description]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                    _cache[38] || (_cache[38] = _createElementVNode("label", null, "Question type", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((localQuestion.value.questionType) = $event)),
                                        class: "form-input"
                                    }, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(questionTypeOptions, (opt) => {
                                            return _createElementVNode("option", {
                                                key: opt.value,
                                                value: opt.value
                                            }, _toDisplayString(opt.text), 9, _hoisted_27);
                                        }), 64))
                                    ], 512), [
                                        [
                                            _vModelSelect,
                                            localQuestion.value.questionType,
                                            void 0,
                                            { number: true }
                                        ]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                    _cache[39] || (_cache[39] = _createElementVNode("label", null, "Correct quiz answer", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((localQuestion.value.correctAnswer) = $event)),
                                        type: "text",
                                        class: "form-input",
                                        placeholder: "Enter correct answer"
                                    }, null, 512), [
                                        [_vModelText, localQuestion.value.correctAnswer]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                                _cache[40] || (_cache[40] = _createElementVNode("label", null, "Explainer quiz answer", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((localQuestion.value.explainer) = $event)),
                                    type: "text",
                                    class: "form-input",
                                    placeholder: "Enter explainer answer"
                                }, null, 512), [
                                    [_vModelText, localQuestion.value.explainer]
                                ])
                            ]),
                            (!_ctx.isNewQuestion)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _cache[48] || (_cache[48] = _createElementVNode("h6", null, "Additional settings", -1)),
                                    _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("label", _hoisted_32, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((localQuestion.value.multipleChoice) = $event)),
                                                type: "checkbox"
                                            }, null, 512), [
                                                [_vModelCheckbox, localQuestion.value.multipleChoice]
                                            ]),
                                            _cache[41] || (_cache[41] = _createTextVNode(" Multiple choice "))
                                        ]),
                                        _createElementVNode("label", _hoisted_33, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((localQuestion.value.outOf) = $event)),
                                                type: "checkbox"
                                            }, null, 512), [
                                                [_vModelCheckbox, localQuestion.value.outOf]
                                            ]),
                                            _cache[42] || (_cache[42] = _createTextVNode(" Out of "))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("div", _hoisted_35, [
                                            _cache[43] || (_cache[43] = _createElementVNode("label", null, "Min amount", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((localQuestion.value.minAmount) = $event)),
                                                type: "number",
                                                class: "form-input",
                                                placeholder: "0"
                                            }, null, 512), [
                                                [
                                                    _vModelText,
                                                    localQuestion.value.minAmount,
                                                    void 0,
                                                    { number: true }
                                                ]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_36, [
                                            _cache[44] || (_cache[44] = _createElementVNode("label", null, "Max amount", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((localQuestion.value.maxAmount) = $event)),
                                                type: "number",
                                                class: "form-input",
                                                placeholder: "7"
                                            }, null, 512), [
                                                [
                                                    _vModelText,
                                                    localQuestion.value.maxAmount,
                                                    void 0,
                                                    { number: true }
                                                ]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_37, [
                                            _cache[45] || (_cache[45] = _createElementVNode("label", null, "Default amount", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((localQuestion.value.defaultAmount) = $event)),
                                                type: "number",
                                                class: "form-input",
                                                placeholder: "0"
                                            }, null, 512), [
                                                [
                                                    _vModelText,
                                                    localQuestion.value.defaultAmount,
                                                    void 0,
                                                    { number: true }
                                                ]
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_38, [
                                        _createElementVNode("div", _hoisted_39, [
                                            _cache[46] || (_cache[46] = _createElementVNode("label", null, "Min label", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((localQuestion.value.minLabel) = $event)),
                                                type: "text",
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, localQuestion.value.minLabel]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_40, [
                                            _cache[47] || (_cache[47] = _createElementVNode("label", null, "Max label", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((localQuestion.value.maxLabel) = $event)),
                                                type: "text",
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, localQuestion.value.maxLabel]
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (isChoiceType.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _cache[51] || (_cache[51] = _createElementVNode("h6", null, "Possible answers (text / sub text / value / icon)", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderedAnswers.value, (answer, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: index,
                                            class: "answer-edit-item",
                                            draggable: "true",
                                            onDragstart: ($event) => (pickupAnswer(index)),
                                            onDragover: _cache[14] || (_cache[14] = _withModifiers(() => { }, ["prevent"])),
                                            onDragenter: _cache[15] || (_cache[15] = _withModifiers(() => { }, ["prevent"])),
                                            onDrop: ($event) => (dropAnswer(index)),
                                            onDragend: _cache[16] || (_cache[16] = ($event) => (draggedAnswerIndex.value = null))
                                        }, [
                                            _cache[49] || (_cache[49] = _createElementVNode("span", { class: "drag-handle" }, "⋮⋮", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event) => ((answer.answer.text) = $event),
                                                type: "text",
                                                class: "form-input",
                                                placeholder: "Answer text"
                                            }, null, 8, _hoisted_43), [
                                                [_vModelText, answer.answer.text]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event) => ((answer.answer.subText) = $event),
                                                type: "text",
                                                class: "form-input",
                                                placeholder: "Sub text"
                                            }, null, 8, _hoisted_44), [
                                                [_vModelText, answer.answer.subText]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event) => ((answer.answer.value) = $event),
                                                type: "text",
                                                class: "form-input value-input",
                                                placeholder: "Value"
                                            }, null, 8, _hoisted_45), [
                                                [_vModelText, answer.answer.value]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event) => ((answer.answer.icon) = $event),
                                                type: "text",
                                                class: "form-input icon-input",
                                                placeholder: "Icon"
                                            }, null, 8, _hoisted_46), [
                                                [
                                                    _vModelText,
                                                    answer.answer.icon,
                                                    void 0,
                                                    { trim: true }
                                                ]
                                            ]),
                                            _createElementVNode("button", {
                                                class: "action-btn danger small",
                                                onClick: ($event) => (removeAnswer(answer))
                                            }, "×", 8, _hoisted_47)
                                        ], 40, _hoisted_42));
                                    }), 128)),
                                    _createElementVNode("div", _hoisted_48, [
                                        _cache[50] || (_cache[50] = _createElementVNode("span", { class: "drag-handle spacer" }, null, -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((newAnswerText).value = $event)),
                                            type: "text",
                                            class: "form-input",
                                            placeholder: "Answer text"
                                        }, null, 512), [
                                            [_vModelText, newAnswerText.value]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((newAnswerSubText).value = $event)),
                                            type: "text",
                                            class: "form-input",
                                            placeholder: "Sub text"
                                        }, null, 512), [
                                            [_vModelText, newAnswerSubText.value]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((newAnswerValue).value = $event)),
                                            type: "text",
                                            class: "form-input value-input",
                                            placeholder: "Value"
                                        }, null, 512), [
                                            [_vModelText, newAnswerValue.value]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((newAnswerIcon).value = $event)),
                                            type: "text",
                                            class: "form-input icon-input",
                                            placeholder: "Icon"
                                        }, null, 512), [
                                            [
                                                _vModelText,
                                                newAnswerIcon.value,
                                                void 0,
                                                { trim: true }
                                            ]
                                        ]),
                                        _createElementVNode("button", {
                                            class: "action-btn primary small",
                                            onClick: addAnswer
                                        }, "+")
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
